import { useTranslation } from '@portals-platform/i18n';
import type { DynamicFieldKey } from '../../../lib/new-certificate/types.js';
import { CertificateDynamicFields } from './certificate-dynamic-field.js';
import { CertificateSection } from './certificate-section.js';

export function SituationSection({ fieldKeys }: { fieldKeys: DynamicFieldKey[] }) {
  const { t } = useTranslation();

  return (
    <CertificateSection title={t('certificates.new.sections.situation')}>
      <CertificateDynamicFields fieldKeys={fieldKeys} />
    </CertificateSection>
  );
}
